<template>
    <v-app id="app-content">
        <v-navigation-drawer
            :mini-variant="!isMobile && primaryDrawer.mini"
            :temporary="isMobile"
            :permanent="!isMobile"
            app
            clipped
            v-model="drawerOpen"
        >
            <div class="d-flex justify-end pa-2" v-if="drawerOpen && isMobile">
                <v-btn
                    icon
                    small
                    color="red"
                    @click="closeDrawer"
                    class="close-drawer-btn"
                >
                    <v-icon small>mdi-close</v-icon>
                </v-btn>
            </div>

            <v-list>
                <router-link
                    class="d-block text-decoration-none"
                    :to="{ name: 'trainings' }"
                    v-if="$store.state.profile.role === 'admin'"
                    @click="handleLinkClick"
                >
                    <v-tooltip right v-if="!isMobile && primaryDrawer.mini">
                        <template v-slot:activator="{ on, attrs }">
                            <v-list-item link v-bind="attrs" v-on="on">
                                <div class="ap-list-button">
                                    <v-icon>mdi-school</v-icon>
                                </div>
                            </v-list-item>
                        </template>
                        <span>{{ $t("title.trainings") }}</span>
                    </v-tooltip>
                    <v-list-item link v-else>
                        <v-list-item-action>
                            <v-icon>mdi-school</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>{{
                                $t("title.trainings")
                            }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </router-link>

                <label
                    class="py-2 pl-4 d-block itb-drawer-label mt-3"
                    v-if="
                        $store.state.profile.role === 'admin' &&
                        variables.is_errors_available == 1
                    "
                >
                    <v-icon v-if="!isMobile && primaryDrawer.mini"
                        >mdi-poll</v-icon
                    >
                    <span v-else>{{ $t("title.analytics") }}</span>
                </label>

                <router-link
                    class="d-block text-decoration-none"
                    :to="{ name: 'results' }"
                    v-if="
                        $store.state.profile.role === 'admin' &&
                        variables.is_errors_available == 1
                    "
                    @click="handleLinkClick"
                >
                    <v-tooltip right v-if="!isMobile && primaryDrawer.mini">
                        <template v-slot:activator="{ on, attrs }">
                            <v-list-item link v-bind="attrs" v-on="on">
                                <div class="ap-list-button">
                                    <v-icon>mdi-list-status</v-icon>
                                </div>
                            </v-list-item>
                        </template>
                        <span>{{ $t("title.results") }}</span>
                    </v-tooltip>
                    <v-list-item link v-else>
                        <v-list-item-action>
                            <v-icon>mdi-list-status</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>{{
                                $t("title.results")
                            }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </router-link>

                <label
                    class="py-2 pl-4 d-block itb-drawer-label mt-3"
                    v-if="$store.state.profile.role === 'admin'"
                >
                    <v-icon v-if="!isMobile && primaryDrawer.mini"
                        >mdi-folder-account-outline</v-icon
                    >
                    <span v-else>{{ $t("title.tenants") }}</span>
                </label>

                <RouterLink
                    v-if="$store.state.tokenData.user.user.tenant_id == '1'"
                    :to="{ name: 'tenants' }"
                    class="d-block text-decoration-none"
                    @click="handleLinkClick"
                >
                    <v-tooltip right v-if="!isMobile && primaryDrawer.mini">
                        <template v-slot:activator="{ on, attrs }">
                            <v-list-item link v-bind="attrs" v-on="on">
                                <div class="ap-list-button">
                                    <v-icon>mdi-bag-personal</v-icon>
                                </div>
                            </v-list-item>
                        </template>
                        <span>{{ $t("title.tenants") }}</span>
                    </v-tooltip>
                    <v-list-item link v-else>
                        <v-list-item-action>
                            <v-icon>mdi-bag-personal</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>{{
                                $t("title.tenants")
                            }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </RouterLink>

                <router-link
                    class="d-block text-decoration-none"
                    :to="{ name: 'licenses' }"
                    v-if="$store.state.profile.role === 'admin'"
                    @click="handleLinkClick"
                >
                    <v-tooltip right v-if="!isMobile && primaryDrawer.mini">
                        <template v-slot:activator="{ on, attrs }">
                            <v-list-item link v-bind="attrs" v-on="on">
                                <div class="ap-list-button">
                                    <v-icon>mdi-card-account-details</v-icon>
                                </div>
                            </v-list-item>
                        </template>
                        <span>{{ $t("title.licenses") }}</span>
                    </v-tooltip>
                    <v-list-item link v-else>
                        <v-list-item-action>
                            <v-icon>mdi-card-account-details</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>{{
                                $t("title.licenses")
                            }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </router-link>

                <router-link
                    class="d-block text-decoration-none"
                    :to="{ name: 'oculus-devices' }"
                    v-if="$store.state.profile.role === 'admin'"
                    @click="handleLinkClick"
                >
                    <v-tooltip right v-if="!isMobile && primaryDrawer.mini">
                        <template v-slot:activator="{ on, attrs }">
                            <v-list-item link v-bind="attrs" v-on="on">
                                <div class="ap-list-button">
                                    <v-icon>mdi-safety-goggles</v-icon>
                                </div>
                            </v-list-item>
                        </template>
                        <span>{{ $t("title.oculus_devices") }}</span>
                    </v-tooltip>
                    <v-list-item link v-else>
                        <v-list-item-action>
                            <v-icon>mdi-safety-goggles</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>{{
                                $t("title.oculus_devices")
                            }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </router-link>

                <router-link
                    class="d-block text-decoration-none"
                    :to="{ name: 'modul' }"
                    v-if="$store.state.tokenData.user.user.tenant_id == '1'"
                    @click="handleLinkClick"
                >
                    <v-tooltip right v-if="!isMobile && primaryDrawer.mini">
                        <template v-slot:activator="{ on, attrs }">
                            <v-list-item link v-bind="attrs" v-on="on">
                                <div class="ap-list-button">
                                    <v-icon>mdi-toy-brick-outline</v-icon>
                                </div>
                            </v-list-item>
                        </template>
                        <span>{{ $t("title.moduls") }}</span>
                    </v-tooltip>
                    <v-list-item link v-else>
                        <v-list-item-action>
                            <v-icon>mdi-toy-brick-outline</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>{{
                                $t("title.moduls")
                            }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </router-link>

                <router-link
                    class="d-block text-decoration-none"
                    :to="{ name: 'download' }"
                    v-if="$store.state.profile.role === 'admin'"
                    @click="handleLinkClick"
                >
                    <v-tooltip right v-if="!isMobile && primaryDrawer.mini">
                        <template v-slot:activator="{ on, attrs }">
                            <v-list-item link v-bind="attrs" v-on="on">
                                <div class="ap-list-button">
                                    <v-icon>mdi-arrow-down-bold-circle</v-icon>
                                </div>
                            </v-list-item>
                        </template>
                        <span>{{ $t("title.app") }}</span>
                    </v-tooltip>
                    <v-list-item link v-else>
                        <v-list-item-action>
                            <v-icon>mdi-arrow-down-bold-circle</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>{{
                                $t("title.app")
                            }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </router-link>

                <label
                    class="py-2 pl-4 d-block itb-drawer-label mt-3"
                    v-if="$store.state.profile.role === 'admin'"
                >
                    <v-icon v-if="!isMobile && primaryDrawer.mini"
                        >mdi-cog-outline</v-icon
                    >
                    <span v-else>{{ $t("title.settings") }}</span>
                </label>

                <router-link
                    class="d-block text-decoration-none"
                    :to="{ name: 'students' }"
                    v-if="$store.state.profile.role === 'admin'"
                    @click="handleLinkClick"
                >
                    <v-tooltip right v-if="!isMobile && primaryDrawer.mini">
                        <template v-slot:activator="{ on, attrs }">
                            <v-list-item link v-bind="attrs" v-on="on">
                                <div class="ap-list-button">
                                    <v-icon>mdi-account-hard-hat</v-icon>
                                </div>
                            </v-list-item>
                        </template>
                        <span>{{ $t("title.students") }}</span>
                    </v-tooltip>
                    <v-list-item link v-else>
                        <v-list-item-action>
                            <v-icon>mdi-account-hard-hat</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>{{
                                $t("title.students")
                            }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </router-link>

                <router-link
                    class="d-block text-decoration-none"
                    :to="{ name: 'users' }"
                    v-if="$store.state.profile.role === 'admin'"
                    @click="handleLinkClick"
                >
                    <v-tooltip right v-if="!isMobile && primaryDrawer.mini">
                        <template v-slot:activator="{ on, attrs }">
                            <v-list-item link v-bind="attrs" v-on="on">
                                <div class="ap-list-button">
                                    <v-icon>mdi-account-multiple</v-icon>
                                </div>
                            </v-list-item>
                        </template>
                        <span>{{ $t("title.users") }}</span>
                    </v-tooltip>
                    <v-list-item link v-else>
                        <v-list-item-action>
                            <v-icon>mdi-account-multiple</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>{{
                                $t("title.users")
                            }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </router-link>

                <router-link
                    class="d-block text-decoration-none"
                    :to="{ name: 'language' }"
                    v-if="$store.state.tokenData.user.user.tenant_id == '1'"
                    @click="handleLinkClick"
                >
                    <v-tooltip right v-if="!isMobile && primaryDrawer.mini">
                        <template v-slot:activator="{ on, attrs }">
                            <v-list-item link v-bind="attrs" v-on="on">
                                <div class="ap-list-button">
                                    <v-icon>mdi-translate</v-icon>
                                </div>
                            </v-list-item>
                        </template>
                        <span>{{ $t("title.language") }}</span>
                    </v-tooltip>
                    <v-list-item link v-else>
                        <v-list-item-action>
                            <v-icon>mdi-translate</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>{{
                                $t("title.language")
                            }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </router-link>

                <label
                    class="py-2 pl-4 d-block itb-drawer-label mt-3"
                    v-if="$store.state.profile.role === 'admin'"
                >
                    <v-icon v-if="!isMobile && primaryDrawer.mini"
                        >mdi-translate</v-icon
                    >
                    <span v-else>{{ $t("title.translates_web") }}</span>
                </label>

                <router-link
                    class="d-block text-decoration-none"
                    :to="{ name: 'translation' }"
                    v-if="$store.state.tokenData.user.user.tenant_id == '1'"
                    @click="handleLinkClick"
                >
                    <v-tooltip right v-if="!isMobile && primaryDrawer.mini">
                        <template v-slot:activator="{ on, attrs }">
                            <v-list-item link v-bind="attrs" v-on="on">
                                <div class="ap-list-button">
                                    <v-icon
                                        >mdi-file-document-edit-outline</v-icon
                                    >
                                </div>
                            </v-list-item>
                        </template>
                        <span>{{ $t("title.translation") }}</span>
                    </v-tooltip>
                    <v-list-item link v-else>
                        <v-list-item-action>
                            <v-icon>mdi-file-document-edit-outline</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>{{
                                $t("title.translation")
                            }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </router-link>

                <router-link
                    class="d-block text-decoration-none"
                    :to="{ name: 'modules_web' }"
                    v-if="$store.state.tokenData.user.user.tenant_id == '1'"
                    @click="handleLinkClick"
                >
                    <v-tooltip right v-if="!isMobile && primaryDrawer.mini">
                        <template v-slot:activator="{ on, attrs }">
                            <v-list-item link v-bind="attrs" v-on="on">
                                <div class="ap-list-button">
                                    <v-icon>mdi-view-module</v-icon>
                                </div>
                            </v-list-item>
                        </template>
                        <span>{{ $t("title.modules_web") }}</span>
                    </v-tooltip>
                    <v-list-item link v-else>
                        <v-list-item-action>
                            <v-icon>mdi-view-module</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>{{
                                $t("title.modules_web")
                            }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </router-link>

                <router-link
                    class="d-block text-decoration-none"
                    :to="{ name: 'licences_web' }"
                    v-if="$store.state.tokenData.user.user.tenant_id == '1'"
                    @click="handleLinkClick"
                >
                    <v-tooltip right v-if="!isMobile && primaryDrawer.mini">
                        <template v-slot:activator="{ on, attrs }">
                            <v-list-item link v-bind="attrs" v-on="on">
                                <div class="ap-list-button">
                                    <v-icon>mdi-license</v-icon>
                                </div>
                            </v-list-item>
                        </template>
                        <span>{{ $t("title.licences_web") }}</span>
                    </v-tooltip>
                    <v-list-item link v-else>
                        <v-list-item-action>
                            <v-icon>mdi-license</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>{{
                                $t("title.licences_web")
                            }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </router-link>

                <router-link
                    class="d-block text-decoration-none"
                    :to="{ name: 'faq_web' }"
                    v-if="$store.state.tokenData.user.user.tenant_id == '1'"
                    @click="handleLinkClick"
                >
                    <v-tooltip right v-if="!isMobile && primaryDrawer.mini">
                        <template v-slot:activator="{ on, attrs }">
                            <v-list-item link v-bind="attrs" v-on="on">
                                <div class="ap-list-button">
                                    <v-icon
                                        >mdi-frequently-asked-questions</v-icon
                                    >
                                </div>
                            </v-list-item>
                        </template>
                        <span>{{ $t("title.FAQ_web ") }}</span>
                    </v-tooltip>
                    <v-list-item link v-else>
                        <v-list-item-action>
                            <v-icon>mdi-frequently-asked-questions</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>{{
                                $t("title.FAQ_web")
                            }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </router-link>
            </v-list>
        </v-navigation-drawer>

        <v-app-bar app clipped-left dark color="primary">
            <v-app-bar-nav-icon @click.stop="toggleDrawer" />
            <v-toolbar-title v-if="!isMobile">
                <img align="middle" src="/images/logo-admin.png" height="30" />
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <template>
                <v-tooltip bottom v-if="$store.state.profile.role === 'admin'">
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            v-bind="attrs"
                            v-on="on"
                            color="yellow"
                            class="mr-2 itb-icon-tooltip"
                            >mdi-crown-outline</v-icon
                        >
                    </template>
                    <span>{{ $t("general.wau_you_are_admin") }}</span>
                </v-tooltip>
                {{ $store.state.profile.email }}
                <v-spacer></v-spacer>
            </template>

            <v-toolbar-title
                v-if="$store.state.tokenData.user.user.tenant_id == '1'"
                class="m-3"
            >
                <v-list-item-title
                    class="text-caption"
                    style="color: #adff2f; font-weight: 600"
                >
                    Main admin
                </v-list-item-title>
            </v-toolbar-title>

            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                        @click="logout"
                        color="deep-orange accent-3"
                    >
                        <v-icon>mdi-logout-variant</v-icon>
                    </v-btn>
                </template>
                <span>{{ $t("general.sign_out") }}</span>
            </v-tooltip>
        </v-app-bar>

        <v-main>
            <router-view></router-view>
        </v-main>

        <v-footer app color="white">
            <span>
                &copy; 2025
                <a href="https://vrband.eu" target="_blank">vr_BAND</a>
            </span>
        </v-footer>
    </v-app>
</template>

<script>
export default {
    data: () => ({
        primaryDrawer: {
            mini: false,
        },
        drawerOpen: false,
        variables: {
            app_domain: "",
            is_division: "",
            is_errors_available: "",
            app_name: "",
        },
    }),

    computed: {
        isMobile() {
            return (
                this.$vuetify.breakpoint.mobile || this.$vuetify.breakpoint.xs
            );
        },
    },

    created() {
        this.getVariables();
        if (!this.isMobile) {
            this.drawerOpen = true;
        }
    },

    watch: {
        isMobile(newVal) {
            if (newVal) {
                this.drawerOpen = false;
                this.primaryDrawer.mini = false;
            } else {
                this.drawerOpen = true;
            }
        },
    },

    methods: {
        getVariables() {
            axios
                .get("/getVariables", {
                    headers: {
                        Authorization:
                            "Bearer " +
                            this.$store.state.tokenData.user.access_token,
                    },
                })
                .then((response) => {
                    this.variables = response.data;
                });
        },

        toggleDrawer() {
            if (this.isMobile) {
                this.drawerOpen = !this.drawerOpen;
            } else {
                this.primaryDrawer.mini = !this.primaryDrawer.mini;
            }
        },

        handleLinkClick() {
            if (this.isMobile) {
                this.drawerOpen = false;
            }
        },

        closeDrawer() {
            if (this.isMobile) {
                this.drawerOpen = false;
            } else {
                this.primaryDrawer.mini = true;
            }
        },

        logout() {
            axios
                .get("/auth/logout", {
                    headers: {
                        Authorization:
                            "Bearer " +
                            this.$store.state.tokenData.user.access_token,
                    },
                })
                .then(() => {
                    localStorage.removeItem("itb-spa-token");
                    this.$store.dispatch("resetState");
                    this.$router.push("/login");
                });
        },
    },
};
</script>

<style scoped>
.close-drawer-btn {
    background-color: #f44336 !important;
    color: white !important;
}

.close-drawer-btn:hover {
    background-color: #d32f2f !important;
}

.close-drawer-btn .v-icon {
    color: white !important;
}
</style>
